import React from 'react'

const DeclinedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20Z"
        fill="#E35E50"
      />
      <path
        d="M15.9992 8.00313C15.5992 7.60313 14.9992 7.60313 14.5992 8.00313L11.9992 10.6031L9.39922 8.00313C8.99922 7.60313 8.39922 7.60313 7.99922 8.00313C7.59922 8.40313 7.59922 9.00312 7.99922 9.40312L10.5992 12.0031L7.99922 14.6031C7.59922 15.0031 7.59922 15.6031 7.99922 16.0031C8.19922 16.2031 8.49922 16.3031 8.69922 16.3031C8.89922 16.3031 9.19922 16.2031 9.39922 16.0031L11.9992 13.4031L14.5992 16.0031C14.7992 16.2031 15.0992 16.3031 15.2992 16.3031C15.4992 16.3031 15.7992 16.2031 15.9992 16.0031C16.3992 15.6031 16.3992 15.0031 15.9992 14.6031L13.3992 12.0031L15.9992 9.40312C16.3992 9.00312 16.3992 8.40313 15.9992 8.00313Z"
        fill="#E35E50"
      />
    </svg>
  )
}

export default DeclinedIcon
